export const accessUser = ({ accessUser }) => accessUser
export const accessUsers = ({ accessUsers }) => accessUsers



// WEBPACK FOOTER //
// ./src/app/pages/access_users/vuex/getters.js